// src/components/ProductSelector.js
import React, { useState, useMemo } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { useAllProducts } from '../hooks/useAllProducts';

export function ProductAutoCompleteCell({
  rowData,
  value,
  onValueChange,
  inputRefMap,
  placeholder = 'Select Product',
}) {
  const { data: products = [], isLoading } = useAllProducts();
  const [filtered, setFiltered] = useState([]);

  // enrich for fast filtering (ensure your hook adds these; or map here)
  const list = useMemo(() =>  products, [products]);
  
  const search = (e) => {
    const q = (e.query || '').toLowerCase().trim();
    const matches = list
      .filter(p => p.nameLower.includes(q) || p.codeLower.includes(q))
      .slice(0, 20);
    setFiltered(matches);
  };

  return (
    <AutoComplete
      value={rowData.product || value}
      suggestions={filtered}
      completeMethod={search}
      field="name"                 
      disabled={isLoading}
      placeholder={placeholder}
      onChange={(e) => onValueChange(rowData.id, 'product', e.value)}
      ref={(el) => { inputRefMap[rowData.id] = el; }}
      // show code in the dropdown list but not in the input
      itemTemplate={(item) => (
        <div className="flex items-center">
          <span>{item.name}</span>
          {item.code ? <span className="ml-2 text-500 text-xs">({item.code})</span> : null}
        </div>
      )}
      selectedItemTemplate={(item) => (item ? item.name : '')}  // ← only name in the field
      required
    />
  );
}
